import {Component, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {FormBuilder} from "@angular/forms";
import {HttpClient} from "@angular/common/http";
import {AuthService} from "angular2-social-login";
import {Conf} from "../settings/config";
import {FunctionsService} from "../services/functions.service";

@Component({
  selector: 'app-meeting-inspire-list',
  templateUrl: './meeting-inspire-list.component.html'
})
export class MeetingInspireListComponent implements OnInit {

  public slug = '';
  banner_image = './assets/images/banners/be-inspired-banner.jpg';

  category = {
    id: '',
    title: '',
    content: '',
    cover_image: ''
  };

  posts = [];
  regions = [];
  categories = [];
  selected_regions = '';
  selected_categories = '';

  next = null;

  constructor(private route: ActivatedRoute, private router: Router, private fb: FormBuilder, private http: HttpClient, public _auth: AuthService) {

  }

  ngOnInit() {
    // this.getRegions();
    this.route.params.subscribe(params => {
      this.next = null;
      if (params.slug) {
        this.slug = params['slug'];
        this.getCategory();
      }
      this.getPost();
    });

    this.getBanner();

    this.getCategories();
  }

  selectCategory(slug) {
    this.slug = slug;
    this.getPost()
  }

  getBanner() {
    this.http.get(Conf.API_URL + '/bar/?slug=inspire').subscribe(
        data => {
          if (data['results'].length) {
            this.category.cover_image = data['results'][0]['cover_image'];
            this.category.content = data['results'][0]['banner_text'];
          }
        },
        error => {
          console.log(error.error)
        }
    );
  }


  getRegions() {
    this.http.get(Conf.API_URL + '/areas/?show_all').subscribe(
        data => {
          this.regions = data['results'];
        },
        error => {
          console.log(error.error)
        }
    );
  }

  getCategory() {
    this.http.get(Conf.API_URL + '/category-for-post/?show_all&slug=' + this.slug).subscribe(
        data => {
          this.category.title = data['results'][0]['title'];
        },
        error => {
          console.log(error.error)
        }
    );
  }

  getCategories() {
    this.http.get(Conf.API_URL + '/category-for-post/?show_all&count=0').subscribe(
        data => {
          this.categories = data['results'];
        },
        error => {
          console.log(error.error)
        }
    );
  }

  choseRegion() {
    this.selected_regions = $('input[name="location"]:checked').map(function () {
      return $(this).val();
    }).get().join(',');
    this.getPost();
  }

  getPost() {
    var url = Conf.API_URL + '/post/?show_all&category=' + this.slug;

    this.http.get(url).subscribe(
        data => {
          this.posts = data['results'];
          this.next = data['next'];
        },
        error => {
          console.log(error.error)
        }
    );
  }

  loadMore() {
    this.http.get(this.next).subscribe(
        data => {
          this.posts = this.posts.concat(data['results']);
          this.next = data['next'];
        },
        error => {
          console.log(error.error)
        }
    );
  }

  firstParagraph(html) {
    return FunctionsService.firstParagraph(html)
  }
}




// WEBPACK FOOTER //
// /var/www/subdomains/codebnb/hanoigo/public_html/client_user/src/app/meeting-inspire-list/meeting-inspire-list.component.ts